<template>
  <div class="u-wrap">
    <div>
      <div class="u-search">
        <input placeholder="请输入标题" v-model="keyword" class="input" />
        <div class="u-btn" @click="clickSearch1">搜索</div>
      </div>
   </div>
    <div class="u-menu-wrap" >
        <van-empty v-if="dataList.length == 0" description="暂无数据" />
       <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading"  offset="20" :finished="finished" :finished-text="finishedTxt" @load="onLoad">
            <div style="width:100vw;">
             <tzgg-card :list="dataList"></tzgg-card>
          </div> 
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { getAction, postAction, postParam } from '@/api/manage'
import uSubsection from '@/components/page/u-subsection.vue'
import tzggCard from '@/views/common/tzgg-card.vue'
export default {
  components: {
    uSubsection,
    tzggCard
  },
  data() {
    return {
      current: 0, // 预设当前项的值
      keyword: '',
      dataList: [],
      loading: false,
      finished: false,
      refreshing: false,
      type: '10',
      pageNo: 0,
      finishedTxt:""
    }
  },
  created() {
    this.onRefresh()
  },
  computed: {},
  methods: {
    getData() {
      let params = { type: '1', pageNo: this.pageNo,'bt':this.keyword};
      getAction('/zhshj/gzfwlbt/page', params).then(res => {
        if (this.refreshing) {
          this.dataList = []
          this.refreshing = false
        }
        let list = res.result.records
        list.map((item, index) => {
          if (item.tp) {
            item.imgUrl = item.tp.split(',')
          }
        })
        this.dataList = this.dataList.concat(list)
        this.loading = false
        if (res.result.pages <= this.pageNo) {
          this.finished = true
          if(this.pageNo!=1){
						this.finishedTxt = "暂无更多了"
					}
        }
      })
    },
    onLoad() {
      this.pageNo++
      this.getData()
    },
    clickSearch1(){
      this.onRefresh();
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false
      this.finishedTxt = ""
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.pageNo = 0
      this.refreshing = true
      this.onLoad()
    }
  }
}
</script>

<style lang="less" scoped>
// @import '../../assets/less/whon-theme.less';
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.u-menu-wrap {
  flex: 1;
}

.u-search {
  padding: 6px 12px;
  display: flex;
  align-items: center;
  background-color: #eeeeef;
}

.u-btn {
  background-color: #3e78f7;
  color: #fff;
  font-size: 14px;
  padding: 2px 12px;
  line-height: 26px;
  margin-left: 12px;
  border-radius: 4px;
   flex-shrink: 0;
}

.input {
  flex: 1;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ededed;
  padding-left: 8px;
  font-size: 14px;
}

::v-deep .van-pull-refresh {
  min-height: 100%;
}
.card2 {
  margin: 0px 8px 10px;
  padding: 12px 8px;
  .title {
    width: 100%;
    position: relative;
    margin: 0px 0px 10px;
    display: flex;
    box-sizing: border-box;
    padding: 0px 0px 0px 10px;
    justify-content: space-between;
    p {
      margin: 0px;
      padding: 0px;
      letter-spacing: 1px;
    }
    p:last-child {
      color: #999;
    }
  }
  .title::before {
    content: '';
    width: 4px;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    background: #39a9ed;
  }
  &-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    div {
      width: 45%;
      height: 70px;
      display: flex;
      margin: 0px 0px 10px;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  &-content2 {
    > div {
      display: flex;
      height: 80px;
      margin: 0px 0px 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      justify-content: space-between;
    }
    &-l {
      width: 80px;
      height: 80px;
      display: flex;
      align-items: center;
      img {
        width: 100%;
        max-height: 80px;
      }
    }
    &-r{
      width: 70%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      justify-content: space-between;
      div{
        display: flex;
        align-items: center;
      }
      p{
        margin: 0px;
        padding: 0px;
        font-size: 14px;
        overflow: hidden;
        line-height: 20px;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        
      }
      img{
        height: 14px;
        margin: 0px 6px 0px 0px;
      }
    }
  }
}
</style>
